import { IFilterElement } from "@saleor/components/Filter";
import { maybe } from "@saleor/misc";
import moment from "moment";

import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam
} from "../../../../utils/filters";
import {
  CustomerInfoFilterKeys,
  CustomerInfoListFilterOpts
} from "../../components/CustomerInfoListPage/filters";
import {
  CustomerInfoListUrlFilters,
  CustomerInfoListUrlFiltersEnum,
  CustomerInfoUrlQueryParams
} from "../../urls";

export const CUSTOMER_REPORTS_FILTERS_KEY = "CustomerInfoFilters";

export function getFilterOpts(
  params: CustomerInfoListUrlFilters
): CustomerInfoListFilterOpts {
  return {
    joined: {
      active: maybe(
        () =>
          [params.joinedFrom, params.joinedTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.joinedTo, ""),
        min: maybe(() => params.joinedFrom, "")
      }
    }
  };
}

export function getFilterVariables(params: CustomerInfoListUrlFilters) {
  const newDate = new Date();
  const endDay = newDate.getDate();
  const endMonth = newDate.getMonth() + 1;
  const endYear = newDate.getFullYear();

  const startDate = moment(newDate.setMonth(newDate.getMonth() - 3)).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(`${endYear}-${endMonth}-${endDay} 00:00:00`)
    .add(1, "days")
    .format("YYYY-MM-DD HH:mm:ssZZ");

  return {
    dateJoined: getGteLteVariables({
      gte: params.joinedFrom
        ? moment(`${params.joinedFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : moment(`${startDate} 00:00:00`).format("YYYY-MM-DD HH:mm:ssZZ"),
      lte: params.joinedTo
        ? moment(`${params.joinedTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : endDate
    }),
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<CustomerInfoFilterKeys>
): CustomerInfoListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CustomerInfoFilterKeys.joined:
      return getMinMaxQueryParam(
        filter,
        CustomerInfoListUrlFiltersEnum.joinedFrom,
        CustomerInfoListUrlFiltersEnum.joinedTo
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CustomerInfoListUrlFilters>(
  CUSTOMER_REPORTS_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CustomerInfoUrlQueryParams,
  CustomerInfoListUrlFilters
>(CustomerInfoListUrlFiltersEnum);
